import { FormActionsMui } from '@app/components/form/actions/FormActionsMui';
import { Page } from '@app/components/page/Page';
import { useToast } from '@app/core/notifications';
import { pushTo } from '@app/core/routing';
import { RudoPlatform } from '@app/modules/social-export/domain/platforms';
import { zodResolver } from '@hookform/resolvers/zod';
import { useSocialExportConnectRudoApiKey } from '@mi-front/api-v2';
import { Grid, Stack } from '@mui/material';
import { FormContainer, TextFieldElement } from 'react-hook-form-mui';
import { useIntl } from 'react-intl';
import { z } from 'zod';
import { rudoConnectMessages } from './rudo-connect-messages';

/**
 * Client-level Rudo access-token connect form. Assign stations after connect.
 */
export function RudoApiKeyConnectPage() {
  const { $t } = useIntl();
  const { notifyError } = useToast();
  const mutation = useSocialExportConnectRudoApiKey();

  return (
    <Page>
      <Page.Header icon={RudoPlatform.Icon()} title={$t(rudoConnectMessages.connectApiKeyTitle)} />
      <Page.Content>
        <FormContainer
          mode="onBlur"
          values={{
            accessToken: '',
            displayName: '',
          }}
          onSuccess={async (data) => {
            try {
              const result = await mutation.mutateAsync({
                data: {
                  accessToken: data.accessToken,
                  displayName: data.displayName.trim() || undefined,
                },
              });
              pushTo(`/admin/social-export/rudo/settings/${result.id}?connectResult=success`);
            } catch (error: unknown) {
              notifyError((error as Error).message);
            }
          }}
          resolver={zodResolver(
            z.object({
              accessToken: z.string().min(1),
              displayName: z.string().optional(),
            }),
          )}
        >
          <Stack spacing={4} useFlexGap>
            <Grid container>
              <Grid item md={6}>
                <TextFieldElement
                  label={$t(rudoConnectMessages.accessToken)}
                  name="accessToken"
                  required
                  fullWidth
                  helperText={$t(rudoConnectMessages.accessTokenHelper)}
                />
              </Grid>
            </Grid>
            <Grid container>
              <Grid item md={6}>
                <TextFieldElement
                  label={$t(rudoConnectMessages.displayName)}
                  name="displayName"
                  fullWidth
                  helperText={$t(rudoConnectMessages.displayNameHelper)}
                />
              </Grid>
            </Grid>
            <FormActionsMui />
          </Stack>
        </FormContainer>
      </Page.Content>
    </Page>
  );
}
